/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";

import { getCorrectResponders, getWinners } from "./competition.api";
import {
  errorMessage,
  formatDate,
  parseDate,
  todayIso,
} from "./competition.constants";

const PAGE_SIZE = 20;

/** Yarışma günlerinden bugünden öncekiler (listeler ertesi gün yayınlanır). */
const publishedDays = (dateBegin, dateEnd) => {
  const days = [];
  const start = parseDate(dateBegin);
  const end = parseDate(dateEnd);
  const today = parseDate(todayIso());
  if (!start || !end) return days;
  for (
    let day = new Date(start);
    day <= end && day < today;
    day.setDate(day.getDate() + 1)
  ) {
    days.push(
      `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, "0")}-${String(day.getDate()).padStart(2, "0")}`
    );
  }
  return days.reverse();
};

/**
 * Kazananlar / Doğru Yanıtlayanlar listesi. Bir günün listesi ertesi gün yayınlanır; yalnızca
 * ad-soyad gösterilir. Güne ve ada göre sorgulanabilir.
 */
const PublicList = ({ competition, kind }) => {
  const isWinners = kind === "WINNERS";
  const days = useMemo(
    () => publishedDays(competition.dateBegin, competition.dateEnd),
    [competition.dateBegin, competition.dateEnd]
  );
  const [date, setDate] = useState("");
  const [nameInput, setNameInput] = useState("");
  const [name, setName] = useState("");
  const [page, setPage] = useState(0);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPage(0);
  }, [kind, date, name]);

  useEffect(() => {
    let active = true;
    const request = isWinners ? getWinners : getCorrectResponders;
    setLoading(true);
    setError("");
    request(competition.id, { page, size: PAGE_SIZE, date, name })
      .then((res) => active && setData(res.data))
      .catch(
        (err) => active && setError(errorMessage(err, "Liste yüklenemedi."))
      )
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [competition.id, kind, date, name, page]);

  const rows = data?.content || [];
  const totalPages = data?.totalPages || 0;

  return (
    <div className="cmp-panel">
      <h2 className="cmp-panel-title">
        {isWinners ? "Kazananlar" : "Doğru Yanıtlayanlar"}
      </h2>
      <p className="cmp-muted">Her günün listesi ertesi gün yayınlanır.</p>

      <form
        className="cmp-filters"
        onSubmit={(event) => {
          event.preventDefault();
          setName(nameInput);
        }}
      >
        <select value={date} onChange={(event) => setDate(event.target.value)}>
          <option value="">Tüm günler</option>
          {days.map((day) => (
            <option key={day} value={day}>
              {formatDate(day)}
            </option>
          ))}
        </select>
        <input
          type="search"
          placeholder="Ad soyad ara"
          value={nameInput}
          maxLength={100}
          onChange={(event) => {
            setNameInput(event.target.value);
            if (!event.target.value) setName("");
          }}
        />
        <button type="submit" className="cmp-btn cmp-btn-primary">
          Ara
        </button>
      </form>

      {error && <div className="cmp-error">{error}</div>}

      <div className="cmp-table-wrap">
        <table className="cmp-table">
          <thead>
            <tr>
              <th>Tarih</th>
              <th>Sıra</th>
              <th>Ad Soyad</th>
              {isWinners && <th>Hediye</th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={`${row.date}-${row.rank}-${index}`}>
                <td className="cmp-col-date">{formatDate(row.date)}</td>
                <td className="cmp-col-rank">{row.rank}</td>
                <td className="cmp-col-name">{row.fullName}</td>
                {isWinners && <td className="cmp-col-gift">{row.giftName}</td>}
              </tr>
            ))}
            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan={isWinners ? 4 : 3} className="cmp-empty">
                  {date || name
                    ? "Sonuç bulunamadı."
                    : isWinners
                      ? "Henüz kazanan yok."
                      : "Henüz doğru yanıtlayan yok."}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="cmp-pager">
          <button
            type="button"
            className="cmp-btn"
            disabled={page === 0 || loading}
            onClick={() => setPage(page - 1)}
          >
            Önceki
          </button>
          <span>
            {page + 1} / {totalPages}
          </span>
          <button
            type="button"
            className="cmp-btn"
            disabled={page + 1 >= totalPages || loading}
            onClick={() => setPage(page + 1)}
          >
            Sonraki
          </button>
        </div>
      )}
    </div>
  );
};

export default PublicList;
